<div class="autoCell-job-container">
    <form class="form-container job-selection-dialog-content" [formGroup]="autoCellDetectForm">
        <cds-form-group>
            <div class="experiment-name-input">
                <cds-input controlWidth="shrink">
                    <label>Name</label>
                    <input type="text" [formControlName]="NEW_EXPERIMENT_NAME_KEY" />
                </cds-input>
            </div>
            <div class="checkbox-group">
                <label>Input feature</label>
                <div>
                    <cds-checkbox>
                        <label>Marker</label>
                        <input
                            type="checkbox"
                            [formControlName]="LAYER_TYPE_MARKERS_KEY"
                            (change)="onMarkerCheckboxChange()"
                        />
                    </cds-checkbox>
                    <div class="marker-options">
                        <ng-container *ngFor="let marker of sourceLayers$ | async">
                            <cds-checkbox>
                                <label>{{ marker.name }}</label>
                                <input
                                    type="checkbox"
                                    [checked]="selectedMarkers.includes(marker.name!)"
                                    (change)="selectMarkers(marker.name!)"
                                />
                            </cds-checkbox>
                        </ng-container>
                    </div>
                    <cds-checkbox>
                        <label>Transcripts</label>
                        <input type="checkbox" [formControlName]="LAYER_TYPE_TRANSCRIPTS_KEY" />
                    </cds-checkbox>
                    <cds-checkbox>
                        <label>Morphometrics</label>
                        <input type="checkbox" [formControlName]="LAYER_TYPE_MORPHOMETRICS_KEY" />
                    </cds-checkbox>
                </div>
            </div>
        </cds-form-group>
        <div class="actions submit-button">
            <cds-button size="sm" (click)="startJob()" [disabled]="!enableJobButton">
                Start Job
            </cds-button>
        </div>
    </form>
</div>
